// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OsGJKuybA2Nm2I {
  position: absolute;
  z-index: 5;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  overflow: hidden;
}
._eVRFnTWuhoMfF {
  position: relative;
  width: 100%;
  border-radius: var(--ds-border-radius-200, 8px) var(--ds-border-radius-200, 8px) 0 0;
}
.OLVTocfMASH9Hj {
  z-index: unset;
  margin: var(--ds-space-0, 0px) var(--ds-space-500, 40px);
  overflow: visible;
}
.HkHn0QTh8MTkn_ {
  position: absolute;
  top: var(--ds-space-250, 20px);
  right: -50px;
  bottom: 50px;
  left: 50px;
  overflow: visible;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stickersWrapper": `OsGJKuybA2Nm2I`,
	"stickers": `_eVRFnTWuhoMfF`,
	"cardBackStickersWrapper": `OLVTocfMASH9Hj`,
	"cardBackStickers": `HkHn0QTh8MTkn_`
};
export default ___CSS_LOADER_EXPORT___;
